import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { selectors, actions } from '../../store/dux/soil-sampling-dux';
import { actions as orderActions } from '../../store/dux/soil-sample-order-dux';
import { useCurrentUser } from '../../hooks/use-current-user';
import { FilterSelector } from '../../components/FilterSelector';

export function FieldSpecialistSelector() {
  const dispatch = useDispatch();
  const selectedFieldSpecialist = useSelector(
    selectors.selectedFieldSpecialist,
  );
  const fieldSpecialists = useSelector(selectors.fieldSpecialists);
  const currentUser = useCurrentUser();

  useEffect(() => {
    dispatch(orderActions.loadAgronomists());
  }, [dispatch]);

  useEffect(() => {
    const current = fieldSpecialists.find(
      (fs) => fs.username === currentUser.username,
    );
    if (current) dispatch(actions.setSelectedFieldSpecialist(current));
  }, [dispatch, currentUser, fieldSpecialists]);

  function handleChange(fieldSpecialist) {
    dispatch(actions.setSelectedFieldSpecialist(fieldSpecialist));
  }

  return (
    <FilterSelector
      isVisible
      selectedOption={selectedFieldSpecialist}
      options={fieldSpecialists}
      onChange={handleChange}
      sortKeys={['name']}
      optionLabelKey="name"
      optionKey="username"
      optionContentKey="name"
      inputLabel="Field Specialist"
    />
  );
}
